export default __webpack_public_path__ + "static/media/quote-straight.2787bc00.png";